<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Subject Groups</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <add-school-class @created="handleCreated"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <school-classes-table :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SchoolClassesTable from '@/components/subject-group/Table/index'
import AddSchoolClass from '@/components/subject-group/Forms/Add/index'

export default {
  components: {
    SchoolClassesTable,
    AddSchoolClass,
  },
  mounted: function() {
    this.getSubjectGroups()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
    }
  },
  methods: {
    getSubjectGroups: function() {
      this.loading = true
      this.$http.get('/api/subject-group', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleCreated: function() {
      this.getSubjectGroups()
    },
    handleUpdateTable: function() {
      this.getSubjectGroups()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getSubjectGroups()
    },
    onChange(current) {
      this.current = current
      this.getSubjectGroups()
    },
  },
}
</script>
